;(function( window, document, $, undefined ) {
	'use strict';

	// Content Animation

	function contentAnimation() {

    // IsVisible Function
    $.fn.isInViewport = function() {
      var elementTop = $(this).offset().top;
      var elementBottom = elementTop + $(this).outerHeight();

      var viewportTop = $(window).scrollTop();
      var viewportBottom = viewportTop + $(window).height();

      return elementBottom > viewportTop && elementTop < viewportBottom;
    };

    function toggleEffectScroll( $el, $target, funcShowContent, funcHideContent ) {
      if( $el.length > 0 ) {
        $el.each(function(){

          var $this = $(this);
          var $parent = $this.closest( $target );

          $(window).scroll(function() {
            if( $parent.isInViewport() ){
              funcShowContent( $this );
            } else {
              funcHideContent( $this );
            }
          });

        });
      }
    }

		// Globals
		return {
      toggleEffectScroll: toggleEffectScroll
		};

	}

	// Globals
	window.callsource = window.callsource || {};
  window.callsource.contentAnimation = contentAnimation();

})( window, document, jQuery );
